module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/cybermonday-sorteo.872c40cf.png";